import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams, Link } from 'react-router-dom';

const UnsubscribePage: React.FC = () => {
  const { t } = useTranslation('common');
  const { status } = useParams<{ status: string }>();
  const isSuccess = status === 'success';

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '60vh',
      padding: '20px',
    }}>
      <div style={{
        maxWidth: '500px',
        textAlign: 'center',
        padding: '40px',
        backgroundColor: '#fff',
        borderRadius: '8px',
        boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
      }}>
        {isSuccess ? (
          <>
            <h2 style={{ color: '#2c3e50', marginBottom: '15px' }}>
              {t('unsubscribe.success_title')}
            </h2>
            <p style={{ color: '#666', lineHeight: 1.6 }}>
              {t('unsubscribe.success_desc')}
            </p>
          </>
        ) : (
          <>
            <h2 style={{ color: '#e74c3c', marginBottom: '15px' }}>
              {t('unsubscribe.invalid_title')}
            </h2>
            <p style={{ color: '#666', lineHeight: 1.6 }}>
              {t('unsubscribe.invalid_desc')}
            </p>
          </>
        )}
        <Link
          to="/"
          style={{
            display: 'inline-block',
            marginTop: '20px',
            padding: '10px 24px',
            backgroundColor: '#3498db',
            color: '#fff',
            textDecoration: 'none',
            borderRadius: '4px',
          }}
        >
          {t('home')}
        </Link>
      </div>
    </div>
  );
};

export default UnsubscribePage;
